export default __webpack_public_path__ + "static/media/servicesSelected.11b0aad5.svg";